import React from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { CalendarCheck2, LogOut, LayoutDashboard, User } from "lucide-react";
import ThemeToggle from "./ThemeToggle";

export default function Navbar() {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  const location = useLocation();

  // Hide navbar when embedded via widget iframe
  const params = new URLSearchParams(location.search);
  if (params.get("embed") === "1") return null;

  const dashLink =
    user?.role === "admin"
      ? "/admin"
      : user?.role === "business"
      ? "/business"
      : "/me";

  return (
    <header className="sticky top-0 z-40 bg-white/70 dark:bg-zinc-950/70 backdrop-blur-xl border-b border-zinc-100 dark:border-zinc-800">
      <div className="max-w-7xl mx-auto px-4 md:px-8 h-16 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2" data-testid="nav-home-logo">
          <div className="h-9 w-9 rounded-2xl bg-zinc-900 text-white dark:bg-zinc-100 dark:text-zinc-900 flex items-center justify-center">
            <CalendarCheck2 className="h-5 w-5" />
          </div>
          <span className="font-display text-xl font-semibold tracking-tight">prenotoo</span>
        </Link>
        <nav className="flex items-center gap-2 md:gap-3">
          <ThemeToggle compact />
          {user ? (
            <>
              <Link to={dashLink} className="btn-secondary h-10 px-4 text-sm" data-testid="nav-dashboard">
                <LayoutDashboard className="h-4 w-4 mr-2" /> Dashboard
              </Link>
              <button
                onClick={async () => { await logout(); nav("/"); }}
                className="h-10 w-10 rounded-full hover:bg-zinc-100 flex items-center justify-center dark:hover:bg-zinc-800"
                data-testid="nav-logout-btn"
                aria-label="Logout"
              >
                <LogOut className="h-4 w-4" />
              </button>
            </>
          ) : (
            <>
              <Link to="/login" className="btn-secondary h-10 px-4 text-sm" data-testid="nav-login">
                <User className="h-4 w-4 mr-2" /> Accedi
              </Link>
              <Link to="/register" className="btn-primary h-10 px-4 text-sm" data-testid="nav-register">
                Registrati
              </Link>
            </>
          )}
        </nav>
      </div>
    </header>
  );
}
